import { graphql } from "gatsby";
import React from "react";
import Layout from "../components/Layout";
import BrandStrip from "../components/home/BrandStrip";
import ContactBand from "../components/home/ContactBand";
import DistributorTerms from "../components/home/DistributorTerms";
import FeaturedProducts from "../components/home/FeaturedProducts";
import Hero from "../components/home/Hero";
import Promotions from "../components/home/Promotions";
import useSession from "../hooks/useSession";
import { SHOW_FEATURED_PRODUCTS } from "../config/features";

/**
 * Home.
 *
 * Es la misma página para todos; lo único que cambia con la sesión iniciada es
 * el bloque de condiciones comerciales, que aparece debajo de las promociones.
 * El H1 del hero es el único H1 de la página.
 */
export default function Home(props) {

	const { isAuthenticated } = useSession();
	const featuredProducts = props.data.allProducts.nodes;

	return (
		<Layout fullBleed>
			<Hero />
			<BrandStrip />
			<Promotions />
			{ isAuthenticated && <DistributorTerms /> }
			{ SHOW_FEATURED_PRODUCTS && <FeaturedProducts products={ featuredProducts } /> }
			<ContactBand />
		</Layout>
	);
}

export const pageQuery = graphql`
    query IndexProducts {
        allProducts(filter: {is_featured: {eq: 1}}) {
            nodes {
                sku
                name
                price
                slug
            }
        }
    }
`;
